import { forwardRef } from 'react';
import MuiOptionsIcon from '@mui/icons-material/MoreVert';
import type { SvgIconProps } from '@mui/material';

const OptionsIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <MuiOptionsIcon ref={ref} {...props} />
));

export default OptionsIcon;
